(() => {
  const controls = document.querySelector('.story-controls');
  if (!controls) return;
  const cards = [...document.querySelectorAll('[data-story]')];
  const buttons = [...document.querySelectorAll('[data-topic-filter]')];
  const search = document.getElementById('story-search');
  const year = document.getElementById('story-year');
  const count = document.getElementById('story-count');
  const empty = document.querySelector('.story-empty');
  let topic = '';
  const normalise = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  function update(writeURL = true) {
    const terms = normalise(search.value.trim()).split(/\s+/).filter(Boolean);
    let visible = 0;
    cards.forEach(card => {
      const matches = (!topic || card.dataset.topic === topic) && (!year.value || card.dataset.year === year.value) && terms.every(term => normalise(card.dataset.search).includes(term));
      card.hidden = !matches;
      if (matches) visible++;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topicFilter === topic)));
    count.textContent = `${visible} ${visible === 1 ? 'story' : 'stories'}${visible !== cards.length ? ` of ${cards.length}` : ''}`;
    empty.hidden = visible !== 0;
    if (writeURL) {
      const url = new URL(window.location.href);
      [['q', search.value.trim()], ['topic', topic], ['year', year.value]].forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      history.replaceState(null, '', url);
    }
  }
  function fromURL() {
    const params = new URLSearchParams(location.search);
    search.value = params.get('q') || '';
    const candidate = params.get('topic') || '';
    topic = buttons.some(b => b.dataset.topicFilter === candidate) ? candidate : '';
    const candidateYear = params.get('year') || '';
    year.value = [...year.options].some(o => o.value === candidateYear) ? candidateYear : '';
    update(false);
  }
  function reset() { topic = ''; search.value = ''; year.value = ''; update(); }
  buttons.forEach(button => button.addEventListener('click', () => { topic = button.dataset.topicFilter; update(); }));
  search.addEventListener('input', () => update());
  year.addEventListener('change', () => update());
  document.getElementById('story-reset').addEventListener('click', reset);
  document.getElementById('story-empty-reset').addEventListener('click', () => { reset(); search.focus(); });
  window.addEventListener('popstate', fromURL);
  controls.hidden = false;
  fromURL();
})();
